@if (isVisible) {
  <div class="emoji-suggestions">
    <div class="emoji-list">
      @if(suggestions.length > 0) {
        @for(emojiItem of suggestions; track emojiItem; let i = $index) {
          <div
            class="emoji-item"
            (click)="selectEmojiSuggestion(emojiItem.emoji)"
            [class.-active]="selectedIndex === i"
            (mouseenter)="focusOn(i)"
            [attr.aria-label]="
              'EMOJI.SUGGESTION' | translate : { emoji: emojiItem.colons }
            "
          >
            <span class="emoji">{{ emojiItem.emoji }}</span>
            <span class="emoji-name">{{ emojiItem.colons }}</span>
          </div>
        }
      } @else {
        <div class="no-emoji-found">
          <div class="detective-icon">🕵️</div>
          <div class="no-emoji-text">{{ "EMOJI.NOTFOUND" | translate }}</div>
        </div>
      }
    </div>
  </div>
}